@if (showMostSearched()) {
  <wl-search-most-searched />
}
<wl-search-autocomplete [searchQuery]="searchQuery()" />
